module.exports = __webpack_public_path__ + "img/ic-edit-light-grey-blue.3c4edc07.svg";